export const visible = false; // Esta característica se usa para ocultar los inputs relacionados a cuentas contables 
export const tab_precio = true; // Habilita el tab de precios por lista en productos
export const tab_combo = false; // Esta característica se usa para ocultar el tab de combo
